import React from 'react'
import circuleBig from '../../images/i-circule-big.svg'
import circuleMedium from '../../images/i-circule-medium.svg'
import circuleSmall from '../../images/i-circule-small.svg'

const DotsBackground = () => {
  return (
    <div>
      <img
        src={circuleBig}
        style={{ position: 'absolute', top: '5%', left: '90%' }}
        alt="dot"
        width="25px"
      ></img>
      <img
        src={circuleSmall}
        style={{ position: 'absolute', bottom: '20px', right: '40px' }}
        alt="dot"
        width="25px"
      ></img>
      <img
        src={circuleSmall}
        style={{ position: 'absolute', top: '40%', right: '2%' }}
        alt="dot"
        width="25px"
      ></img>
      <img
        src={circuleMedium}
        style={{ position: 'absolute', bottom: '20%', left: '3%' }}
        alt="dot"
        width="25px"
      ></img>
    </div>
  )
}

export default DotsBackground
